import ActionHelper from "../helpers/ActionHelper";

export const getPerson = (id) =>
  ActionHelper.requestServer("GET", "/person/" + id);

export const updatePerson = (id, form) =>
  ActionHelper.requestServer("PUT", "/person/" + id, form);



// WEBPACK FOOTER //
// ./src/actions/personActions.js